import { createAsyncThunk } from '@reduxjs/toolkit';
import { atsJobsActions } from './atsJobsReducer';
import { createApiAction } from '../shared/createApiAction';
import type { ApiRequestOptions, ThunkArgs } from '../shared/createApiAction';

// todo: need to update these, for now added some sample
const actionsConfig = {
  createJob: {
    method: 'post',
    endpoint: '/ats_jobs',
    thunkName: 'createJob',
    reducerName: 'createJob',
    responseKey: 'data',
  },
  updateJob: {
    method: 'put',
    endpoint: '/ats_jobs/:jobId',
    thunkName: 'updateJob',
    reducerName: 'updateJob',
  },
  cloneJob: {
    method: 'post',
    endpoint: '/ats_jobs/:jobId/clone',
    thunkName: 'cloneJob',
    reducerName: 'cloneJob',
    responseKey: 'data',
  },
  createOffice: {
    method: 'post',
    endpoint: '/ats_offices',
    thunkName: 'createOffice',
    reducerName: 'createOffice',
    responseKey: 'data',
  },
  getAllJobs: {
    method: 'get',
    endpoint: '/ats_jobs',
    thunkName: 'getAllJobs',
    reducerName: 'getAllJobs',
    responseKey: 'data',
  },
  archiveJob: {
    method: 'put',
    endpoint: '/ats_jobs/:jobId/archive',
    thunkName: 'archiveJob',
    reducerName: 'archiveJob',
    responseKey: 'data',
  },
  closeJob: {
    method: 'put',
    endpoint: '/ats_jobs/:jobId/close',
    thunkName: 'closeJob',
    reducerName: 'closeJob',
  },
  reopenJob: {
    method: 'put',
    endpoint: '/ats_jobs/:jobId/reopen',
    thunkName: 'reopenJob',
    reducerName: 'reopenJob',
  },
};

const apiAction = createApiAction({
  actions: atsJobsActions,
  successPayload: (result) => ({
    errors: result?.errors,
    flash: result?.flash,
  }),
  trackStaleReads: true,
});

export const atsJobsApiActions = (actionId, config: ApiRequestOptions = {}) => {
  // note: to use params, pass it directly inside requestConfig like below
  // requestConfig: { params: queryParams }
  const currentAction = actionsConfig[actionId];
  const { isApi } = config;
  if (!currentAction)
    return console.error('no actions config found for ats jobs');

  const { endpoint, thunkName } = currentAction;

  if (isApi) {
    return (...args: ThunkArgs) => {
      return apiAction({ ...currentAction, endpoint }, config, args);
    };
  }

  return (...args: ThunkArgs) => {
    return createAsyncThunk(
      thunkName as string,
      // Pre-existing shape: a promise sits where a payload creator belongs.
      apiAction({ ...currentAction, endpoint }, config, args) as never
    );
  };
};
